module.exports = " <input type=search :placeholder=\"translate('cp.search')\" @keydown.esc.prevent=reset v-model=keyword class=\"filter-control search\" debounce=500 /> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/dossier/DossierSearch.vue
// module id = 548
// module chunks = 0